
import React from 'react';
import { Spinner } from '@primer/react';
import { formatLogDateTimeUTC } from '../../helpers/dates';
import { UserActionResponse, ACTION_TYPE_LABELS, STATUS_LABELS, getEntityName, isMany } from '../../types/api/logs';
import { TableColumn } from '../common/TableComponent';

interface LogColumnsOptions {
    users: boolean;
    openingId?: string;
    openUser: (id: string) => void;
    openEntity: (log: UserActionResponse) => void;
}

export const logsTableConfig = ({ users, openingId, openUser, openEntity }: LogColumnsOptions): TableColumn<UserActionResponse>[] => [
    { id: 'userId', title: 'ID пользователя', sortable: false, filtered: true,
        render: log => log.userId ? <button onClick={() => openUser(log.userId!)}>ID{log.user?.number ?? log.userId}</button> : 'Пользователь не определён' },
    { id: 'logActionType', title: 'Тип действия', sortable: false, filtered: true,
        render: log => ACTION_TYPE_LABELS[log.actionType] ?? log.actionType },
    { id: 'description', title: 'Описание действия', sortable: false,
        render: log => log.description?.trim() || 'Нет данных' },
    { id: 'created_at', title: 'Дата и время (UTC)', sortable: true,
        render: log => formatLogDateTimeUTC(log.createdAt) },
    { id: 'logStatus', title: 'Статус выполнения действия', sortable: false, filtered: true,
        render: log => log.status ? STATUS_LABELS[log.status] ?? 'Нет данных' : 'Нет данных' },
    { id: 'logEntityType', title: 'Объект действия', sortable: false, filtered: true,
        render: log => {
            const title = `${getEntityName(log) || 'Нет данных'}${log.entity?.title && !isMany(log.entityType) ? ` "${log.entity.title}"` : ''}`;
            const canOpen = !!log.entityId && ['ad', 'user', 'comment', 'chat', 'review', 'post', 'topic', 'profile', 'moderator'].includes(log.entityType);
            if (openingId === log.id) return <Spinner size="small" />;
            return canOpen ? <button onClick={() => openEntity(log)}>{title}</button> : title;
        } },
    ...(users ? [
        { id: 'appScreen', title: 'Название экрана/раздела', sortable: false, render: (log: UserActionResponse) => log.appScreen || 'Нет данных' },
        { id: 'clientVersion', title: 'Версия клиента', sortable: false, render: (log: UserActionResponse) => log.clientVersion || 'Нет данных' },
    ] : []),
];
